import { HStack, Skeleton, VStack } from "@chakra-ui/react";
import { CHART_HEIGHT } from "./constants";

export const TreemapChartSkeleton = ({ ...boxProps }) => {
    return (
        <VStack width="100%" align="flex-start" height={CHART_HEIGHT} {...boxProps} gap="2px" overflow="hidden">
            <HStack spacing="2px" width="100%">
                <Skeleton h="300px" flex="3" />
                <Skeleton h="300px" flex="2" />
                <Skeleton h="300px" flex="0.5" />
                <VStack spacing="2px" flex="0.5">
                    <Skeleton h="150px" width="100%" />
                    <Skeleton h="100px" width="100%" />
                    <Skeleton h="46px" width="100%" />
                </VStack>
                <VStack spacing="2px" flex="0.5">
                    <Skeleton h="150px" width="100%" />
                    <Skeleton h="100px" width="100%" />
                    <Skeleton h="46px" width="100%" />
                </VStack>
            </HStack>
            <HStack spacing="2px" align="flex-start" width="100%">
                <VStack flex="3" gap="2px">
                    <Skeleton h="300px" width="100%" />
                </VStack>
                <VStack flex="2" gap="2px">
                    <Skeleton h="100px" width="100%" />
                    <Skeleton h="150px" width="100%" />
                </VStack>
                <VStack flex="0.5" gap="2px">
                    <Skeleton h="100px" width="100%" />
                    <Skeleton h="150px" width="100%" />
                </VStack>

                <VStack flex="1.5" gap="2px">
                    <Skeleton h="80px" width="100%" />
                    <Skeleton h="80px" width="100%" />
                    <Skeleton h="90px" width="100%" />
                </VStack>
                <VStack flex="1" gap="2px">
                    <Skeleton h="80px" width="100%" />
                    <Skeleton h="80px" width="100%" />
                    <Skeleton h="90px" width="100%" />
                </VStack>
            </HStack>
        </VStack>
    );
};
